import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorTooltipComponent } from './error-tooltip.component';

@NgModule({
  declarations: [ErrorTooltipComponent],
  imports: [CommonModule],
  exports: [ErrorTooltipComponent]
})
export class ErrorTooltipModule {}
